export const SET_POIS = "SET_POIS";



// WEBPACK FOOTER //
// ./src/constants/poi.js